import { getColorGradation } from '@hzero-front-ui/core';
import { fontVariables } from '@hzero-front-ui/font';
var primary = '#29BECE';
var primaryColors = getColorGradation(primary);
var neutralColor = getColorGradation('#000000');
var greenColors = getColorGradation('#11D954');
var yellowColors = getColorGradation('#FBAD00');
var redColors = getColorGradation('#F23A50');
var blueColors = getColorGradation('#3889FF'); // const cyanColors = getColorGradation('#18CCF0');

var purplColors = getColorGradation('#5438E6'); // const orangeColors = getColorGradation('#F07630');
// const magentaColors = getColorGradation('#E62EA3');

var defaultIconfontFamily = fontVariables.defaultIconfontFamily;
var commonData = {
  name: 'common',
  data: [{
    defaultColor: primary,
    defaultIconfontFamily: defaultIconfontFamily,
    fontFamily: 'MicrosoftYaHei',
    primary: primary,
    primary1: primaryColors.step1,
    // #f0fffe
    primary2: primaryColors.step2,
    // #d6fffe
    primary3: primaryColors.step3,
    // #a6f5f5
    primary4: primaryColors.step4,
    // #79e4e8
    primary5: primaryColors.step5,
    // #4fd2db
    primary6: primaryColors.step6,
    // #29becf
    primary7: primaryColors.step7,
    // #1995a8
    primary8: primaryColors.step8,
    // #0d6f82
    primary9: primaryColors.step9,
    // #054a5c
    //中性色
    titleColor1: neutralColor.step10,
    titleColor2: 'rgba(0, 0, 0, 0.85)',
    titleColor3: '#8c8c8c',
    titleColor4: '#e0e0e0',
    // lineColor1: neutralColor.step5,
    lineColor1: '#e6e6e6',
    lineColor2: '#f0f0f0',
    lineColor3: '#f5f5f5',
    lineColor4: '#fafafa',
    // pureBlack: neutralColor.step13,
    fontColor: '#fff',
    darkFontColor: '#333',
    bgColor: '#fff',
    // icon字体
    // iconfontFamily: 'hzero-c7n-font',
    // 基础提示色
    successColor: '#38C638',
    warningColor: '#FFBC00',
    errorColor: '#F02B2B',
    //功能色
    infoColor: blueColors.step6,
    successBgColor: '#e6fff5',
    infoBgColor: '#e6ebf5',
    errorBgColor: '#ffeae6',
    warningBgColor: '#fffbe6',
    //辅助色
    redColor1: redColors.step1,
    redColor2: redColors.step2,
    redColor3: redColors.step3,
    redColor4: redColors.step4,
    redColor5: redColors.step5,
    redColor6: redColors.step6,
    redColor7: redColors.step7,
    redColor8: redColors.step8,
    redColor9: redColors.step9,
    blueColor1: blueColors.step1,
    blueColor2: blueColors.step2,
    blueColor3: blueColors.step3,
    blueColor4: blueColors.step4,
    blueColor5: blueColors.step5,
    blueColor6: blueColors.step6,
    blueColor7: blueColors.step7,
    blueColor8: blueColors.step8,
    blueColor9: blueColors.step9,
    greenColor1: greenColors.step1,
    greenColor2: greenColors.step2,
    greenColor3: greenColors.step3,
    greenColor4: greenColors.step4,
    greenColor5: greenColors.step5,
    greenColor6: greenColors.step6,
    greenColor7: greenColors.step7,
    greenColor8: greenColors.step8,
    greenColor9: greenColors.step9,
    yellowColor1: yellowColors.step1,
    yellowColor2: yellowColors.step2,
    yellowColor3: yellowColors.step3,
    yellowColor4: yellowColors.step4,
    yellowColor5: yellowColors.step5,
    yellowColor6: yellowColors.step6,
    yellowColor7: yellowColors.step7,
    yellowColor8: yellowColors.step8,
    yellowColor9: yellowColors.step9,
    purplColor1: purplColors.step1,
    purplColor2: purplColors.step2,
    purplColor3: purplColors.step3,
    purplColor4: purplColors.step4,
    purplColor5: purplColors.step5,
    purplColor6: purplColors.step6,
    purplColor7: purplColors.step7,
    purplColor8: purplColors.step8,
    purplColor9: purplColors.step9,
    // CheckBox
    disabledCheckBoxBgColor: '#F9F9F9',
    disabledCheckBoxBorderColor: '#CCCCCC'
  }]
};
export default commonData;